import axios from "axios";
import services from "@/config/services";
import authHeader from "../auth/auth-header";
import Cookies from "js-cookie";
import FileManager from "@/services/ask-file-manager/index.js";

export default class TeamsystemBilanciService {
  static interceptorSet = false;

  constructor() {
    this.praticheUrl = `${services.ask_pratiche_base.url}`;
    this.basePath = `${this.praticheUrl}/api/teamsystem`;

    this.paths = {
      anagrafici: `${this.basePath}/anagrafici`,
      saldi: `${this.basePath}/saldi`,
    };

    this.filemanager = new FileManager();

    if (!TeamsystemBilanciService.interceptorSet) {
      axios.interceptors.request.use((req) => {
        req.headers["Authorization"] = authHeader();
        req.headers["Params"] =
          Cookies.get("google_access_token") || Cookies.get("ask_access_token");
        return req;
      });

      TeamsystemBilanciService.interceptorSet = true;
    }
  }

  assertType(type) {
    if (!["anagrafici", "saldi"].includes(type)) {
      throw new Error(`Tipologia non valida: ${type}`);
    }
  }

  buildUploadFormData(file) {
    const formData = new FormData();
    formData.append("file", file);
    return formData;
  }

  // =========================
  // Upload
  // =========================
  async upload(type, file) {
    this.assertType(type);

    if (!file) {
      throw new Error("File mancante.");
    }

    const formData = this.buildUploadFormData(file);

    const res = await axios.post(`${this.paths[type]}/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  }

  // =========================
  // History
  // =========================
  async getHistory(type, params = {}) {
    this.assertType(type);

    const res = await axios.get(`${this.paths[type]}/history`, { params });
    return res.data;
  }

  // =========================
  // Rows (paginazione server)
  // =========================
  /**
   * params supportati (backend):
   * - page (1..)
   * - per_page (1..200)
   * - sort_field
   * - sort_order: 'asc'|'desc'
   * - q
   * - data_bilancio: 'YYYY-MM-DD'
   */
  async getRows(type, params = {}) {
    this.assertType(type);

    const safeParams = {
      page: params.page ?? 1,
      per_page: params.per_page ?? 25,
      sort_field: params.sort_field ?? undefined,
      sort_order: params.sort_order ?? undefined,
      q: params.q ?? undefined,
      data_bilancio: params.data_bilancio ?? undefined,
    };

    const res = await axios.get(`${this.paths[type]}/rows`, { params: safeParams });
    return res.data;
  }

  // =========================
  // Download (flow backend: download-info + download stream)
  // =========================
  async getDownloadInfo(type, uploadId) {
    this.assertType(type);

    const res = await axios.get(`${this.paths[type]}/download-info/${uploadId}`);
    return res.data; // { file_name, stored_path }
  }

  async downloadFromBackend(type, uploadId) {
    this.assertType(type);

    const info = await this.getDownloadInfo(type, uploadId);

    const res = await axios.post(
      `${this.paths[type]}/download`,
      { stored_path: info.stored_path },
      { responseType: "blob" }
    );

    const blob = new Blob([res.data]);
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = info.file_name || "download";
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    return true;
  }

  downloadByPath(path) {
    if (!path) {
      throw new Error("Path mancante.");
    }

    this.filemanager.download(path);
    return true;
  }

  async download(type, item) {
    this.assertType(type);

    if (item?.download_url) {
      window.open(item.download_url, "_blank");
      return true;
    }

    if (item?.id) {
      await this.downloadFromBackend(type, item.id);
      return true;
    }

    if (item?.stored_path || item?.path) {
      this.downloadByPath(item.stored_path || item.path);
      return true;
    }

    throw new Error("Dati file mancanti per il download.");
  }
}